<!--
レポート出力画面
-->

<template>
  <div>
    <div class="ml-2 mt-12 text-h5">{{ title }}</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px">
      <v-row
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="3">
          <v-subheader class="title mr-2" style="height: 100%">
            基準日
          </v-subheader>
        </v-col>

        <v-col cols="4">
          <custom-date-picker
            :dateSub="date"
            :events="events"
            :minDate="minDate"
            :maxDate="maxDate"
            :defaultFocus="defaultFocus"
            @on-update-registration-date="selectDate"
          ></custom-date-picker>
        </v-col>

      </v-row>
    </v-container>
    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn color="primary" class="ma-2" width="200" @click="download"
            >ダウンロード</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CustomDatePicker from "../../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    alert: Alert,
  },
  data() {
    this.$nextTick(() => { });

    // カレンダーが選択できる最小の日付
    this.minDate = "2021-10-01";
    // 基準日
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    var nowYear = yesterday.getFullYear();
    var nowMonth = ("00" + (yesterday.getMonth() + 1)).slice(-2);
    var nowDay = ("00" + yesterday.getDate()).slice(-2);
    this.date = nowYear + "-" + nowMonth + "-" + nowDay;
    this.maxDate = this.date;
    // フォーカスの初期値
    this.defaultFocus = new DateWrapper(yesterday).format.systemDate;

    this.title = "レポート出力";

    // CSVファイル格納URL
    this.fileUrl = "";

    return {
      events: {},
      errors: [],
    };
  },
  methods: {
    /**
     * 基準日を画面から取得する
     */
    selectDate(selectDate) {
      // API指定用基準日
      this.date = selectDate.replace(/-/g, "/");
    },
    /**
     * 対象ファイルをダウンロードする
     */
    downloadCsv() {
      const url = this.fileUrl;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = this.targetFileName;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    /**
     * レポート取得
     */
    download() {
      // レポート取得
      let updateUrl = "";
      this.clearMessage();

      updateUrl = "/umilog/getreport";

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, {date: this.date.replace(/-/g, "/")})
        .then((result) => {
          // ファイル名を取得
          this.targetFileName = result.file_name;
          // ファイルパスを取得
          this.fileUrl = result.file_url;
          // 対象ファイルをダウンロードする
          this.downloadCsv();
          this.$store.commit("setWaiting", false);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("ダウンロードに失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
